import { render, staticRenderFns } from "./BehaviorView.vue?vue&type=template&id=4e996a18&"
import script from "./BehaviorView.vue?vue&type=script&lang=js&"
export * from "./BehaviorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports